import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Scroll-triggered fade + rise reveal.
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal used by the hero. `lines` is an array of strings.
export function MaskLines({ lines, className = "", lineClassName = "", startDelay = 0.2 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-reveal">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: startDelay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Simple fade for supporting text.
export function FadeIn({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
